import Vue from 'vue';

Vue.component('add-to-list', require('@/components/Lists/AddToList').default);

Vue.component('create-lists', require('@/components/Lists/Create').default);
Vue.component('update-lists', require('@/components/Lists/Update').default);
Vue.component('delete-lists', require('@/components/Lists/Delete').default);
Vue.component('duplicate-lists', require('@/components/Lists/Duplicate').default);
Vue.component('unfollow-lists', require('@/components/Lists/Unfollow').default);
Vue.component('view-lists', require('@/components/Lists/GridLists').default);
Vue.component('add-trip-dates-lists', require('@/components/ListsSchedules/AddTripDates').default);
Vue.component('add-to-schedule-modal', require('@/components/ListsSchedules/AddToSchedule').default);

Vue.component('delete-spot-from-list', require('@/components/Lists/Spots/Delete').default);
Vue.component('list-spots', require('@/components/Lists/ListSpots').default);
Vue.component('map-spots-view', require('@/components/Lists/MapSpotsView').default);
Vue.component('mobile-map-controls', require('@/components/Maps/MobileControls').default);
Vue.component('edit-list-spot-caption-dialog', require('@/components/Lists/Spots/EditCaptionModal').default);

Vue.component('post-comments', require('@/components/Posts/Comments').default);

